import React from "react";
import GroupMessageDetails from "../../../Common/GroupChatComponent/GroupMessageDetails";

export default function TeamMessages({ teamoverview }) {
  return (
    <div>
      <GroupMessageDetails teamoverview={teamoverview} />
    </div>
  );
}
